module.exports = __webpack_public_path__ + "img/six.a47da08e.png";